import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { createLinkClickHandler } from './utils';

export const useSoftRedirect = (wrapperSelector: string, deps: any[]) => {
  const router = useRouter();
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const regexp = new RegExp(
        `^/(.+)?|(http(s)?://)?(${document.location.hostname}|(www.)?reas.cz)(:\\d{4})?/?(/.+)?`,
      );

      // filter only the links that are on our website
      const links = Array.from<HTMLAnchorElement>(
        document.querySelectorAll(wrapperSelector + ' a'),
      ).filter((link) => {
        const href = link.getAttribute('href');
        if (href && href.match(regexp)) return true;
      });

      const handlers: ((e: MouseEvent) => void)[] = [];

      links.forEach((link, index) => {
        handlers[index] = createLinkClickHandler(link, router);
        link.addEventListener('click', handlers[index]);
      });

      return () =>
        links.forEach((link, index) =>
          link.removeEventListener('click', handlers[index]),
        );
    }
  }, deps);
};
